import Request from 'app/shared-view/gd/data/request'

module.exports = class ApiSharedEvents {

    setPublicKey(value) {
        this.publicKey = value;
    }

    getEvent(eventId) {
        return new Request(this,'GET',this.publicKey+'/e/'+eventId);
    }
}